import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getVehicleScoreYears } from '../../services/VehiclesService';
import { VehicleScoreYears } from '../../types/Vehicles';
import { FeaturesManagement } from '../../../featuresControl';

function useGetVehicleScoreYears(
  id: string,
  fleetId: string,
  from: number,
  to?: number,
): UseQueryResult<VehicleScoreYears> {
  return useQuery(
    ['vehicle-score-years', id, fleetId, from, to],
    async (): Promise<VehicleScoreYears> => getVehicleScoreYears(id, fleetId, from, to),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled: !!id && !!from,
    },
  );
}

export default useGetVehicleScoreYears;
